export const TABS = {
    GRAMMAR_IN_USE_LESSON: [
        { path: '/grammar-in-use/section', label: 'Lessons' },
    ],
    GRAMMAR_IN_USE_SECTION: [
        { path: '/grammar-in-use/section', label: 'Content' },
        { path: '/grammar-in-use/exercises', label: 'Exercises' },
    ],
    PROGRAM: [
        { path: '/programs/submitted', label: 'Submitted' },
        { path: '/programs/draft', label: 'Draft' },
    ],
    TUTORS: [
        { path: '/training/tutors', label: 'Data' },
    ],
    REGISTER_TEST: [
        { path: '/training/register-test', label: 'Students' },
    ],
    TRIAL_ACCOUNT: [
        { path: '/training/trail-accounts', label: 'Data' },
    ],
    BATCHES: [
        { path: '/training/batches', label: '' },
    ],
    PROGRAM_LEVEL: [
        { path: '/programs/program', label: 'Levels', route: 'program' },
    ],
    PROGRAM_LESSON: [
        { path: '/programs/level', label: 'Lessons', route: 'level' },
        { path: '/programs/vocabulary-test', label: 'Vocabulary Test', route: 'vocabulary-test' },
        { path: '/programs/grammar-test', label: 'Grammar Test', route: 'grammar-test' },
        { path: '/programs/reading-test', label: 'Reading Test', route: 'reading-test' },
        { path: '/programs/listening-test', label: 'Listening Test', route: 'listening-test' },
    ],
    PROGRAM_MODULE: [
        { path: '/programs/module', label: 'Modules', route: 'module' },
    ],
    DICTIONARY: [
        { path: '/dictionary/draft', label: 'Draft' },
        { path: '/dictionary/submitted', label: 'Submitted' },
        { path: '/dictionary/deleted', label: 'Deleted' },
    ],

    LEVEL: [
        // { path: '/levels/draft', label: 'Draft' },
        { path: '/levels/submitted', label: 'Training Level' },
        // { path: '/levels/deleted', label: 'Deleted' },
    ],
    LESSON: [
        // { path: '/lessons/draft', label: 'Draft' },
        { path: '/lessons/submitted', label: 'Submitted' },
        // { path: '/lessons/deleted', label: 'Deleted' },
    ],
    MODULE: [
        // { path: '/modules/draft', label: 'Draft' },
        { path: '/modules', label: 'Lessons' },
        // { path: '/modules/deleted', label: 'Deleted' },
    ],
    GRAMMAR_IN_USE: [
        { path: '/grammar-in-use/submitted', label: 'Submitted' },
    ],
    ACTIVITY: [
        { path: '/modules/activities/submitted', label: 'Activities' },
        { path: '/modules/activities/deleted', label: 'Deleted' },
    ],
    sentence_completion: [
        { path: '/modules/activity-type/sentence_completion/reading', label: 'Reading', key: 'reading' },
        { path: '/modules/activity-type/sentence_completion/listening', label: 'Listening', key: 'listening' },
        { path: '/modules/activity-type/sentence_completion/grammar', label: 'Grammar', key: 'grammar' },
    ],
    MULTIPLE_CHOICE: [
        { path: '/modules/activity-type/multiple_choice/reading', label: 'Reading', key: 'reading' },
        { path: '/modules/activity-type/multiple_choice/listening', label: 'Listening', key: 'listening' },
        { path: '/modules/activity-type/multiple_choice/grammar', label: 'Grammar', key: 'grammar' },
    ],
    keyVocabulary: [
        { path: '/modules/activity-type/key_vocabulary/vocabulary', label: 'Vocabulary', key: 'vocabulary' },
    ],
    PICTURE_DESCRIPTION: [
        { path: '/modules/activity-type/picture_description/vocabulary', label: 'Vocabulary', key: 'vocabulary' },
    ],
    picture_description_speaking: [
        { path: '/modules/activity-type/picture_description_speaking/speaking', label: 'Speaking', key: 'speaking' },
    ],
    GRAMMAR: [
        { path: '/modules/activity-type/grammar/grammar', label: 'Grammar', key: 'grammar' },
    ],
    CONVERSATION: [
        { path: '/modules/activity-type/conversation/speaking', label: 'Speaking', key: 'speaking' },
    ],
    introduction_dialogue: [
        { path: '/modules/activity-type/introduction_dialogue/listening', label: 'Listening', key: 'listening' },
    ],
    WORD_PRONUNCIATION: [
        { path: '/modules/activity-type/word_pronunciation/speaking', label: 'Speaking', key: 'speaking' },
    ],
    SENTENCE_PRONUNCIATION: [
        { path: '/modules/activity-type/sentence_pronunciation/speaking', label: 'Speaking', key: 'speaking' },
    ],
    MATCHING_EXERCISE: [
        { path: '/modules/activity-type/matching_exercise/reading', label: 'Reading', key: 'reading' },
        { path: '/modules/activity-type/matching_exercise/listening', label: 'Listening', key: 'listening' },
        { path: '/modules/activity-type/matching_exercise/grammar', label: 'Grammar', key: 'grammar' },
    ],
    WORD_CLASS: [
        { path: '/modules/activity-type/word_class/vocabulary', label: 'Vocabulary', key: 'vocabulary' },
        { path: '/modules/activity-type/word_class/grammar', label: 'Grammar', key: 'grammar' },
    ],
    REWORDING: [
        { path: '/modules/activity-type/rewording/grammar', label: 'Grammar', key: 'grammar' },
    ],
    SENTENCE_STRUCTURE: [
        { path: '/modules/activity-type/sentece_structure/grammar', label: 'Grammar', key: 'grammar' },
    ],
    DICTATION: [
        { path: '/modules/activity-type/dictation/listening', label: 'Listening', key: 'listening' },
    ],
    HANGMAN: [
        { path: '/modules/activity-type/hangman/vocabulary', label: 'Vocabulary', key: 'vocabulary' },
    ],
    COMMON_MISTAKES: [
        { path: '/modules/activity-type/common_mistakes/vocabulary', label: 'Vocabulary', key: 'vocabulary' },
    ],
    INTERESTING_ARTICLE: [
        { path: '/modules/activity-type/interesting_article/reading', label: 'Reading', key: 'reading' },
    ],
    SHORT_STORY: [
        { path: '/modules/activity-type/short_story/reading', label: 'Reading', key: 'reading' },
    ],
    TONGUE_TWISTER: [
        { path: '/modules/activity-type/tongue_twister/speaking', label: 'Speaking', key: 'speaking' },
    ],
}

export const BOOK_STORE_TABS = {
    TRENDING: [
        { path: '/book-store/trending/submitted', label: 'Data', key: 'data' },
    ],
    GENRES: [
        { path: '/book-store/genres/submitted', label: 'Data', key: 'data' },
    ],
    SECTIONS: [
        { path: '/book-store/sections/submitted', label: 'Data', key: 'data' },
    ],
    BOOKS: [
        { path: '/book-store/books/submitted', label: 'Data', key: 'data' },
    ],
    PUBLISHER: [
        { path: '/book-store/publisher/submitted', label: 'Data', key: 'data' },
    ],
    AUTHOR: [
        { path: '/book-store/author/submitted', label: 'Data', key: 'data' },
    ],
    SLIDES: [
        { path: '/book-store/slides/submitted', label: 'Data', key: 'data' },
    ],
    STUDENTS: [
        { path: '/enrollment/students/submitted', label: 'Data', key: 'data' },
    ],
    TUTORS: [
        { path: '/enrollment/tutors/submitted', label: 'Data', key: 'data' },
    ],
    CLASSROOMS: [
        { path: '/enrollment/classrooms/submitted', label: 'Data', key: 'data' },
    ],
    REGISTER_TESTING: [
        { path: '/enrollment/register-test/submitted', label: 'All Students', key: 'submitted' },
    ],
    STUDENT_ADMISSION: [
        { path: '/enrollment/admissions/submitted', label: 'Data', key: 'Students' },
    ],
}

export const TESTING_CENTER = {
    PLACEMENT_TEST: [
        { path: '/testing-center/placement-test/vocabulary/vocabulary_pi', label: 'Vocabulary PI' },
        { path: '/testing-center/placement-test/grammar/grammar_be', label: 'Grammar PI' },
        // { path: '/testing-center/placement-test/grammar/grammar_pi', label: 'Grammar PI' },
        // { path: '/testing-center/placement-test/grammar/grammar_ua', label: 'Grammar UA' },

        // { path: '/testing-center/placement-test/listening/listening_be', label: 'Listening BE' },
        // { path: '/testing-center/placement-test/listening/listening_pi', label: 'Listening PI' },
        // { path: '/testing-center/placement-test/listening/listening_ua', label: 'Listening UA' },

        { path: '/testing-center/placement-test/reading/reading_b', label: 'Reading BE' },
        // { path: '/testing-center/placement-test/reading/reading_e', label: 'Reading E' },
        { path: '/testing-center/placement-test/reading/reading_p', label: 'Reading PI' },
        // { path: '/testing-center/placement-test/reading/reading_i', label: 'Reading I' },
        { path: '/testing-center/placement-test/reading/reading_u', label: 'Reading UA' },
        // { path: '/testing-center/placement-test/reading/reading_a', label: 'Reading A' },
    ],
    GENERAL_TESTING: [
        { path: '/testing-center/general-placement-test/classes', label: 'Classes' },
    ],

    GENERAL_TESTING_SKILL: [
        { path: '/testing-center/general-placement-test/math', label: 'Math' },
        { path: '/testing-center/general-placement-test/physic', label: 'Physic' },
        { path: '/testing-center/general-placement-test/chemistry', label: 'Chemistry' },
        { path: '/testing-center/general-placement-test/biology', label: 'Biology' },
        { path: '/testing-center/general-placement-test/earth', label: 'Earth' },
    ],
    BOOK_CLUB: [
        { path: '/book-club/general-knowledge', label: 'Classes' },
    ],
    BOOK_CLUB_MATERIAL: [
        { path: '/book-club/material', label: 'Reading' },
    ],
    AUDIO_READING: [
        { path: '/audio-reading/library', label: 'Library', key: 'library' },
        { path: '/audio-reading/level', label: 'Level', key: 'level' },
        // { path: '/audio-reading/english-type', label: 'English Type', key: 'english-type' },
        { path: '/audio-reading/format', label: 'Format', key: 'format' },
        { path: '/audio-reading/target-age', label: 'Target Age', key: 'target-age' },
        { path: '/audio-reading/type', label: 'Type', key: 'type' },
        // { path: '/audio-reading/words', label: 'Words', key: 'words' },
    ],

    APP_SLIDE: [
        { path: '/app-center/slides', label: 'Data', key: 'data' },
    ],
    READING_LEVEL: [
        { path: '/book-store/levels', label: 'Data', key: 'data' },
    ],
    APP_VIDEOS: [
        { path: '/app-center/videos', label: 'Data', key: 'data' },
    ],
    APP_SKILL: [
        { path: '/app-center/skills', label: 'Data', key: 'data' },
    ],
    APP_CATEGORY: [
        { path: '/app-center/category', label: 'Data', key: 'data' },
    ],
    APP_NEW_AND_TRENDING: [
        { path: '/app-center/books/new_and_trending', label: 'Data', key: 'data' },
    ],
    APP_BOOKS_WE_LOVE: [
        { path: '/app-center/books/books_we_love', label: 'Data', key: 'data' },
    ],
    APP_SPECIAL_OFFERS_AND_FREE: [
        { path: '/app-center/books/special_offers_and_free', label: 'Data', key: 'data' },
    ],
    APP_TOP_CHARTS: [
        { path: '/app-center/books/top_charts', label: 'Data', key: 'data' },
    ],
    READING_MEMBERS: [
        { path: '/members/students', label: 'Students', key: 'students' },
        { path: '/members/training', label: 'Language Training', key: 'training' },
        { path: '/members/teachers', label: 'Teachers', key: 'teachers' },
        { path: '/members/parents', label: 'Parents', key: 'parents' },
    ],
    READING_BATCH_MEMBERS: [
        { path: '/reading-batches/batches', label: 'Batches', key: 'batches' },
    ],
    READING_SCHOOL: [
        { path: '/schools/data', label: 'Data', key: 'data' },
    ],
    ACADEMIC_YEAR: [
      { path: '/year/data', label: 'Data', key: 'data' },
  ],
    IMPORT_STUDENT: [
        { path: '/import-cam-reading-student/data', label: 'Data', key: 'data' },
    ],
}

